export default __webpack_public_path__ + "img/ceHCyjuM.4cf57e41.svg";